import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FileService } from '../../services/file.service';
import { DocumentData } from '../../employee-overview/employee-overview.domain';
import { FileData } from '../../constants/app.constants';
import { ErrorService } from '../../services/error/error.service';
import { EnvironmentService } from '../../services/environment.service';

@Component({
  selector: 'app-nested-file',
  templateUrl: './nested-file.component.html',
  styleUrls: ['./nested-file.component.scss'],
})
export class NestedFileComponent implements OnInit {
  @Input() documents: any;
  @Input() taId: string;
  @Input() isReadonly: boolean = false;
  @Output() fileEvent = new EventEmitter();
  nestedFileForm: any = FormGroup;

  constructor(
    private fb: FormBuilder,
    private fileService: FileService,
    private ref: ChangeDetectorRef,
    private errorService: ErrorService,
    public environmentService: EnvironmentService
  ) {
    this.nestedFileForm = this.fb.group({
      fileForm: this.fb.array([this.fileFormData()]),
    });
  }

  fileFormData(): FormGroup {
    return this.fb.group({
      name: new FormControl({ value: null, disabled: false }, [Validators.required]),
      filename: new FormControl({ value: null, disabled: false }),
      filesize: new FormControl({ value: null, disabled: false }),
    });
  }

  ngOnInit(): void {
    this.setFiles();
  }

  setFiles(): void {
    if (this.documents && this.documents.length > 0) {
      const control = this.nestedFileForm.get('fileForm') as FormArray;

      const excludedFileNames = [
        FileData.BUSINESSREGISTRATION,
        FileData.PROOFOFQUALIFICATION,
        FileData.PROOFOFEXPERTISE,
        FileData.PROOFOFCONTRACT,
        FileData.ENTRYINTRADEREGISTER,
        FileData.ENTRYATCHAMBEROFHANDICRAFTS,
        FileData.PROOFOFINDEMNITYINSURANCE,
        FileData.PROOFOFVDESUBSCRIPTION,
        FileData.IDCARDMAINFRAUD,
        FileData.WELDINGCERTIFICATECONFIRMATION,
        FileData.PROOF80HOURSTRWI,
        FileData.ONEDAYTRAININGTRGI2018,
        FileData.ONEDAYTRAININGTRWI,
        FileData.GASCOURSECENTRALHEATINGVENTILATIONDURATION,
        FileData.PROOF100HOURSTRGI,
      ];

      this.documents.forEach(x => {
        if (!excludedFileNames.includes(x.name)) {
          control.push(this.setFormData(x));
        }
      });

      control.removeAt(0);
    }
  }

  uploadHandler(event, index, form): void {
    const name = this.nestedFileForm.controls.fileForm.controls[index].controls.name.value;
    if (name !== '' && name !== null && name !== undefined) {
      this.fileService.uploadDocuments(event, this.taId, name).subscribe(
        () => {
          form.clear();
          this.fileEvent.emit();
        },
        error => {
          form.clear();
          this.errorService.throwErrorIfFailure(error, true);
        }
      );
    } else {
      form.clear();
    }
  }

  checkInputForAvailableDocuments(index: number): boolean {
    const name = this.nestedFileForm.controls.fileForm.controls[index].controls.name.value;
    if (name === null || name === '' || name === undefined) {
      return false;
    } else {
      return this.fileService.checkForAvailableDocuments(this.documents, name);
    }
  }

  checkForAvailableDocuments(index: number): boolean {
    const name = this.nestedFileForm.controls.fileForm.controls[index].controls.name.value;
    if (name === null || name === '' || name === undefined) {
      return true;
    } else {
      return this.fileService.checkForAvailableDocuments(this.documents, name);
    }
  }

  downloadFile(documentId: string, fileName?: string): void {
    this.fileService.readDocument(documentId).subscribe((response: Blob) => {
      this.fileService.downloadDocument(response, fileName);
    });
  }

  removeFile(documentId: string): void {
    this.fileService.removeFile(documentId).subscribe(() => {
      const index = this.fileService.checkIndex(this.documents, documentId);
      if (index !== -1) {
        this.documents.splice(index, 1);
      }
      this.ref.detectChanges();
    });
  }

  addForm(): void {
    const control = this.nestedFileForm.controls.fileForm;
    control.push(this.fileFormData());
  }

  removeRow(index: number): void {
    const name = this.nestedFileForm.controls.fileForm.controls[index].controls.name.value;
    if (name !== '' && name !== null && name !== undefined) {
      const document: DocumentData[] = this.fileService.getDimensionsByFilter(this.documents, name);
      if (document !== null && document !== undefined && document.length > 0) {
        this.removeFile(document[0].document_id);
        const control = this.nestedFileForm.controls.fileForm;
        control.removeAt(index);
        this.ref.detectChanges();
      } else {
        const control = this.nestedFileForm.controls.fileForm;
        control.removeAt(index);
        this.ref.detectChanges();
      }
    } else {
      const control = this.nestedFileForm.controls.fileForm;
      control.removeAt(index);
    }
  }

  setFormData(data: any): FormGroup {
    return this.fb.group({
      name: new FormControl({ value: data.name, disabled: false }, [Validators.required]),
      filename: new FormControl({ value: data.filename, disabled: false }),
      filesize: new FormControl({ value: data.filesize, disabled: false }),
    });
  }
}
